<template>
  <RequireAdContract>
    <Content :description="description" class="campaigns">
      <template slot="title">
        <div class="row">
          <div class="columns">
            <h1>{{ $t('ADVERTISEMENT.CAMPAIGNS.CREATE_CAMPAIGN') }}</h1>
          </div>
          <div class="columns shrink">
            <ElButton type="text" @click="showContract">
              {{ $t('ADVERTISEMENT.CAMPAIGNS.SHOW_CONTRACT') }}
            </ElButton>
          </div>
        </div>
      </template>
      <AddCampaign @add="redirectAndUpdateCampaignLists" />
    </Content>

    <AdContract v-model="isShowingContract" />
  </RequireAdContract>
</template>

<script>
import RequireAdContract from '../common/RequireAdContract';
import AdContract from '../common/AdContract';
import AddCampaign from './AddCampaign';

import layout from '@/mixins/layout';

import Content from '@@/common/layout/Content';

import createController from '@/utils/controller';
import { campaignTypes } from './common/constants';
import storage from '@/services/storage';

const LAST_USED_CAMPAIGN_KEY = 'last-created-campaign-type';
const campaignsUpdateController = createController('update');
const CAMPAIGN_TYPES_ROUTES = {
  DISCOVERY: 'discovery-ads-campaigns-list',
  SEARCH: 'search-ads-campaigns-list',
  BASIC: 'basic-ads-campaigns-list',
};

export default {
  name: 'Campaigns',

  components: {
    AddCampaign,
    Content,
    RequireAdContract,
    AdContract,
  },

  mixins: [layout],
  data() {
    return {
      isShowingContract: false,
    };
  },

  computed: {
    description() {
      return this.$t('ADVERTISEMENT.CAMPAIGNS_LIST.DESC', {
        link: `<a class="link" href="http://ads.cafebazaar.ir/" target="_blank">${this.$t(
          'ADVERTISEMENT.THIS_LINK',
        )}</a>`,
      });
    },
    campaignsUpdateController() {
      return campaignsUpdateController;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (to.name === 'advertisement-campaigns') {
      const defaultTab = 'BASIC';
      const destinationTab = storage.read(LAST_USED_CAMPAIGN_KEY) || defaultTab;
      next({ name: CAMPAIGN_TYPES_ROUTES[destinationTab] });
    } else {
      next();
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (to.name === 'advertisement-campaigns') {
      next(false);
    } else {
      next();
    }
  },

  created() {
    this.setPageTitle('ADVERTISEMENT.TITLE');
  },
  methods: {
    showContract() {
      this.isShowingContract = true;
    },
    redirectAndUpdateCampaignLists(campaignType) {
      storage.write(LAST_USED_CAMPAIGN_KEY, campaignType);
      this.updateCampaignLists(campaignType);

      this.redirectToTabIfNotActive(campaignType);
    },
    updateCampaignLists(campaignType) {
      this.campaignsUpdateController.update(campaignType);
    },
    redirectToTabIfNotActive(campaignType) {
      const destinationRoute = CAMPAIGN_TYPES_ROUTES[campaignType];

      if (this.$route.name === destinationRoute) {
        return;
      }

      if (campaignTypes.DISCOVERY === campaignType) {
        this.$router.push({ name: CAMPAIGN_TYPES_ROUTES[campaignType] });
      } else if (campaignTypes.SEARCH === campaignType) {
        this.$router.push({ name: CAMPAIGN_TYPES_ROUTES[campaignType] });
      } else if (campaignTypes.BASIC === campaignType) {
        this.$router.push({ name: CAMPAIGN_TYPES_ROUTES[campaignType] });
      }
    },
  },
};
</script>

<style lang="scss">
.campaigns {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      margin: 0;
    }
  }
}
</style>
